import { useMemo } from 'react';
import { useLocalStorage } from './useLocalStorage';

export const useLeftMenuOpen = () => {
  const [leftMenuState, setLeftMenuState] = useLocalStorage<string>('yabble-left-menu-state', 'open');

  const isLeftMenuOpen = useMemo(() => {
    return leftMenuState === 'open';
  }, [leftMenuState]);

  return { isLeftMenuOpen, setLeftMenuState };
};
